import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeleteConfirmationModalComponent } from '../modals';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-reference-table-component',
    templateUrl: './reference-component.html',
    styleUrls: ['./reference-component.scss']
})

export class RefrenceTableComponent implements OnInit {
    @Input() data_array : Array<any>;
    @Output() delete = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();

    constructor(private modalService: NgbModal) {
    	
    }

    ngOnInit() {}

    deleteAction(data){
        const modalRef = this.modalService.open(DeleteConfirmationModalComponent);
              const p1 = this.getRelaitonshipString(data.relationship);
              const p2 = data.company != null ? data.company.company_name_en : data.company_name
              modalRef.componentInstance.Title = " "+p1+"/"+p2;
              modalRef.result.then((result) => {
                    if(result.status)
                        this.delete.emit(data.id);
                  }).catch((error) => {
              });
    }

    editAction(data){
        this.edit.emit({... data});
    }

    getRelaitonshipString(relaitonship){
        switch (relaitonship) {
            case 1007 : 
                return "Previous Line Manager";
                break;
            case 1008 : 
                return "Present Line Manager";
                break;
            case 1009 : 
                return "Previous Indirect Manager";
                break;
            case 1010 : 
                return "Present Indirect Manager";
                break;
            case 1011 : 
                return "Previous Colleague";
                break;
            case 1012 : 
                return "Present Colleague";
                break;
            case 1013 : 
                return "Previous Subordinate";
                break;
            case 1014 : 
                return "Present Subordinate";
                break;
            case 1015 : 
                return "Non-work related Acquaintance";
                break;
        }
        return "Other";
    }
}
